module.exports = __webpack_public_path__ + "img/senioren.499465bb.jpg";